module.exports = __webpack_public_path__ + "static/2-e3a1f983aa1dc4f134c2912e40fd4f6d.jpg";